import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { src: String, id: String }
  static targets = ['image']

  connect() {
    this.#addLoadingIcon()
    this.#loadFullImage()
  }

  // TODO: load the image only when is visible in the viewport?
  #loadFullImage() {
    const img = new Image()
    img.src = this.srcValue
    img.onload = () => {
      this.imageTarget.src = img.src
      this.imageTarget.classList.add('loaded')
      this.#removeLoadingIcon()
      this.#notifyImageLoaded()
    }
  }

  #notifyImageLoaded() {
    document.dispatchEvent(new CustomEvent('image-loaded', { detail: { id: this.idValue } }))
  }

  #addLoadingIcon() {
    const loadingIconContainer = document.createElement('div')
    loadingIconContainer.classList.add('image-loading--overlay')
    loadingIconContainer.innerHTML = '<div class="image-loading--overlay-icon"></div>'
    this.element.appendChild(loadingIconContainer)
  }

  #removeLoadingIcon() {
    const loadingIconContainer = this.element.querySelector('.image-loading--overlay')
    if (loadingIconContainer) {
      loadingIconContainer.remove()
    }
  }
}
